// extracted by mini-css-extract-plugin
module.exports = {"manage-inspector-container":"card-settings-inspector_manage-inspector-container__2mLT5"};